module.exports = __webpack_public_path__ + "img/logo3.06f4f0d2.png";